import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ChatBotHeaderComponent } from '../chat-bot-header/chat-bot-header.component';
import { TitleCasePipe, KeyValuePipe } from '@angular/common';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { ChatPromptsComponent } from '../chat-prompts/chat-prompts.component';
import { L10nTranslatePipe } from 'angular-l10n';


@Component({
  selector: 'miq-chat-prompts-panel',
  templateUrl: './chat-prompts-panel.component.html',
  styleUrl: './chat-prompts-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ChatBotHeaderComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    ChatPromptsComponent,
    TitleCasePipe,
    KeyValuePipe,
    L10nTranslatePipe
],
})
export class ChatPromptsPanelComponent {
  readonly defaultPrompts = input<Record<string, string[]>>({});
  readonly windowSizeIncreased = input(false);
  readonly emitToggleWindowSize = output<boolean>();
  readonly emitPromptSelected = output<string>();
  readonly emitStartNewSession = output<void>();

  handlePromptClick(prompt: string): void {
    this.emitPromptSelected.emit(prompt);
  }

  toggleWindowSize(event: boolean): void {
    this.emitToggleWindowSize.emit(event);
  }

  startNewSession(): void {
    this.emitStartNewSession.emit();
  }
}
